import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';

class DropDownChonKyThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue} require={this.props.require} isValid={this.props.isValid} options={this.props.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonKyThanhTra.defaultProps = {
  className: 'input-group',
  label: 'Kỳ thanh tra',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name:''
}

let bindStateToProps = state => {
  return {
    data: [
      {giaTri: 2015, ten: '2015'},
      {giaTri: 2016, ten: '2016'},
      {giaTri: 2017, ten: '2017'},
      {giaTri: 2018, ten: '2018'},
      {giaTri: 2019, ten: '2019'},
      {giaTri: 2020, ten: '2020'},
    ]
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonKyThanhTra));


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonkythanhtra.jsx